//@*/*
//    *RPD Forms Appv0.91
//    * Copyright (c) 2025, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//

/* eslint-disable */

const home = () => import("../components/home.vue");
const ToDo = () => import("../components/ToDo.vue");
const remove_record = () => import("../components/remove_record.vue");
const pagenoutfound = () => import("../components/pagenoutfound.vue");
const viewone = () => import("../components/viewone.vue");

export const routes = [
  {
    name: "ToDo",
    path: "/ToDo",
    component: ToDo,
    display: "ToDo",
  },

  {
    name: "home",
    path: "/",
    component: home,
    display: "home",
  },
  {
    name: "viewone",
    path: "/viewone",
    component: viewone,
    display: "viewone",
  },
  {
    name: "remove_record",
    path: "/remove_record",
    component: remove_record,
    display: "remove_record",
  },

  { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
